import queryString from 'query-string';

export default queryString;
